











































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'

@Component
export default class VarietyGrowthList extends Vue {
  @Prop() private data!: any

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }

  /* 作業ステータスの判定 */
  private judgmentStatus (status: number) {
    switch (status) {
      case 1:
        return '完成版'

      case 2:
        return '暫定版'

      case 3:
        return '情報未入手'

      default:
        return '-'
    }
  }
}
